import React from "react"
import {FormGroup} from "@blueprintjs/core"
import moment from "moment"
import Props from "../../../core/components/props"
import "./FilterOptionPanel.scss"
import DatePickerDialog from "../../../core/components/DatePickerDialog"

export interface DoubleInputProps extends Props {
    valueFrom: Date
    valueTo: Date
    setValueFrom: (value: Date) => void
    setValueTo: (value: Date) => void
}

const DoubleDateInput: React.FC<DoubleInputProps> = (props) => {
    return (
        <div style={{display: "flex"}}>
            <FormGroup inline label="between" labelFor="from">
                <div style={{display: "flex"}}>
                    <div> {moment(props.valueFrom).format("DD-MM-YYYY")}</div>
                    <DatePickerDialog
                        selectedValue={props.valueFrom}
                        setSelectedValue={(date: Date) =>
                            props.setValueFrom(date)
                        }
                    />
                </div>
            </FormGroup>
            <FormGroup inline label="to" labelFor="to">
                <div style={{display: "flex"}}>
                    {moment(props.valueTo).format("DD-MM-YYYY")}
                    <DatePickerDialog
                        selectedValue={props.valueTo}
                        setSelectedValue={(date: Date) =>
                            props.setValueTo(date)
                        }
                    />
                </div>
            </FormGroup>
        </div>
    )
}

export default DoubleDateInput
